module.exports = __webpack_public_path__ + "static/media/trenazer-rowerowy-interaktywny-suito-t.5cd248fb.jpeg";